import type { PlanConfig, ReportConfig, ReportConfigurationLookupOption } from "../types";
import type { ReportLogicContext } from "./context";
import { buildRuleBook, ruleBookPlainText } from "./narrative";

function planPreviewText(plan: PlanConfig) {
    const lines = [`Health Plan = "${plan.name || plan.clientName || "Selected Client"}"`];
    if (plan.clientId) lines.push(`ClientId = ${plan.clientId}`);
    lines.push("Report filters are configured on each report's Setup tab.");
    return lines.join("\n");
}

/**
 * The saved plainEnglishText carried in configJson.generatedQueries[].
 *
 * This is now one call into the narrative layer rather than a second, independently
 * maintained description of the same configuration. The words a reader sees in the Rule
 * Book and the words stored with the saved config are therefore the same words - which is
 * what stops the two drifting, as they had before narrative.ts existed. `lookupValues` is
 * kept in the signature for callers that still pass it; value names now come from the
 * lookup catalog on the context, which covers every column rather than the handful this
 * map carried.
 */
function buildPlainEnglish(
    context: ReportLogicContext,
    plan: PlanConfig,
    report?: ReportConfig,
    _lookupValues: Record<string, string[]> = {},
    clientOptions?: ReportConfigurationLookupOption[],
) {
    if (!report) return "Select a report to see its live preview here.";
    return ruleBookPlainText(buildRuleBook(context, plan, report, clientOptions));
}

export {
    planPreviewText,
    buildPlainEnglish,
};
